





























import { Component, Vue, Prop } from 'vue-property-decorator';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import { ItoggleEvent } from '@/components/Checkbox/CheckBoxTypes';

@Component({
  components: {
    Checkbox,
    ClipLoader
  }
})
export default class ToggleBox extends Vue {
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop({ default: '' }) caption?: string;
  @Prop({ default: '' }) error?: string;
  @Prop({ default: '' }) value!: string;
  @Prop({ default: false }) checked!: boolean;
  @Prop({ default: false }) onFalseError!: boolean;
  @Prop({ default: false }) centralized!: boolean;
  @Prop({ default: false }) loading?: boolean;

  selected: boolean = this.checked;

  changed(event: ItoggleEvent) {
    this.selected = event.state;
    this.$emit('changed', event);
  }

  get hasError() {
    return this.onFalseError && this.error && !this.checked;
  }
}
